<template>
      <div class="flex animate-pulse hover:shadow-xl hover:transition-all hover:-translate-y-1 flex-col items-stretch bg-white w-full rounded-sm shadow-md">
            <div class="image w-full aspect-video bg-slate-50 overflow-hidden flex-none">
                  <div class="object-cover object-center w-full h-full bg-gray-200 ">
                  </div>
            </div>

            <div class="infos p-6 relative flex-1 flex flex-col justify-end">
            <div class="tags mb-2 line-clamp-1 uppercase text-gray-400 text-xs bg-gray-200 h-4">
            </div>
            <div class="text-2xl font-medium capitalize bg-gray-200 h-8">
            </div>
            <div class="not-italic text-orange font-medium bg-gray-200 h-4">
            </div>
            <div class="absolute aspect-square w-10 flex items-center justify-center bottom-0 right-0">
                  <span class="fa-regular fa-angle-right text-white"></span>
            </div>
            </div>
      </div>
</template>